export default "__VITE_ASSET__BiOQiIR8__"